/**
 * お問い合わせフォーム（直接送信）
 * - お問い合わせ内容の文字数カウンター（0/500文字）
 * - 送信完了後にサンクスページへリダイレクト
 */
const contactForm = () => {
  // 文字数カウンター
  document.querySelectorAll('[data-char-count]').forEach((counter) => {
    const field = document.getElementById(
      counter.getAttribute('data-char-count'),
    );
    const output = counter.querySelector('.js-char-count');
    if (!field || !output) return;

    const update = () => {
      output.textContent = String([...field.value].length);
    };
    field.addEventListener('input', update);
    update();
  });

  // 送信完了 → サンクスページへ
  document.addEventListener('wpcf7mailsent', () => {
    const thanksUrl =
      window.entryFormConfig?.thanksPageUrl || '/contact/thanks/';
    window.location.href = thanksUrl;
  });

  // CF7 サーバ側バリデーションで弾かれた時：最初のエラーまでオートスクロール
  // .wpcf7-not-valid は wpcf7invalid 発火の「後」に CF7 が付与するため
  // setTimeout で DOM 反映を待つ（公式 DOM events 推奨パターン）
  document.addEventListener('wpcf7invalid', (event) => {
    setTimeout(() => {
      const wrapper = event.target;
      const firstInvalid =
        wrapper?.querySelector('.wpcf7-not-valid') ??
        document.querySelector('.wpcf7-not-valid');
      if (!firstInvalid) return;

      const row =
        firstInvalid.closest('.m-contact-form__row') ??
        firstInvalid.closest('.wpcf7-form-control-wrap') ??
        firstInvalid;
      const headerHeight =
        parseInt(
          getComputedStyle(document.documentElement).getPropertyValue(
            '--js-height__header',
          ),
        ) || 0;
      const scrollTop =
        window.scrollY + row.getBoundingClientRect().top - headerHeight - 24;
      window.scrollTo({ top: scrollTop, behavior: 'smooth' });
    }, 100);
  });
};

export { contactForm };
